/*
Sohel 03/25/2023 2699762545 File Upload Changes
Akhila 03/25/2023 2699762545 Added condition in upload file prepopulating"
Akhila 03/28/2023 2699762545 Added uploaded doc info message
Akhila 03/28/2023 2699762545 Added file size validation
Akhila 03/28/2023 2699762545 Added 10MB file size
Akhila 03/28/2023 2699762545 file format type change to .dot and .dotx
*/
import React, {useEffect, useState} from 'react';
import {
  Box,
  Button,
  List,
  ListItem,
  Typography,
  Tooltip,
  FormHelperText,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import {useDropzone} from 'react-dropzone';
import {useSelector} from 'react-redux';

const useStyles = makeStyles((theme) => ({
  boxDrop: {
    padding: '2px 0px 0px 0px',
  },
  previewImg: {
    maxHeight: '1122px !important',
    maxWidth: '794px !important',
    height: 'auto',
    width: 'auto',
  },
  fileText: {
    margin: '10px 0 0',
    fontSize: '12px',
    fontWeight: 700,
    color: '#000000',
  },
  extendedIcon: {
    marginRight: theme.spacing(3),
    marginBottom: '7px',
  },
  uploadText: {
    fontSize: '17px !important',
    paddingTop: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  uploadContent: {
    fontSize: '17px !important',
    paddingBottom: '10px',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px !important',
    },
  },
  filePara: {
    textAlign: 'center !important',
    marginTop: '15px !important',
  },
  actionButton: {
    textTransform: 'capitalize',
    fontSize: '0.9rem',
    color: '#056c93',
    fontWeight: 600,
    padding: '5px 30px 5px 30px',
    borderRadius: '5px',
    backgroundColor: 'transparent',
    outline: 'none',
    border: '2px solid #056c93',
    [theme.breakpoints.down('md')]: {
      fontSize: '13px',
      marginTop: '10px',
    },
  },
  documentText: {
    fontWeight: '600 ',
    fontSize: '15px ',
    cursor: 'pointer ',
    padding: '10px 5px',
    textAlign: 'center',
    color: '#056c93',
  },
}));

const DragAndDrop = ({
  selectedFile,
  setSelectedFile,
  setFieldValue,
  error,
  helperText,
  uploadedFile,
  capturedImages,
  oldFile,
  viewhandler,
  viewIconCond,
  setFilePathName,
  values,
  fileSizeError,
  setFileSizeError,
}) => {
  const classes = useStyles();
  const [files, setFiles] = useState('');
  const fileSize = '10MB';
  const maxSize = 10485760n;
  const [filePath, setFilePath] = useState(false);
  const [fetchedFile, setFetchedFile] = useState('');
  // const getTemplateType = (type) => {
  //   if (type === "HTML") {
  //     return ".html";
  //   } else if (type === "PDF") {
  //     return "application/pdf";
  //   } else {
  //     return "application/pdf,.html";
  //   }
  // };
  const {letterFormatData} = useSelector(
    ({newLetterMaintenance}) => newLetterMaintenance,
  );
  const {getRootProps, getInputProps, open, acceptedFiles, fileRejections} = useDropzone({
    // Disable click and keydown behavior
    noClick: true,
    noKeyboard: true,
    multiple: false,
    maxSize: maxSize,
    accept:
      'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    onDrop: (acceptedFiles) => {
      setSelectedFile('uploadedFile', acceptedFiles);
    },
  });
  const isFileTooLarge =
    fileRejections && fileRejections.length > 0 && fileRejections[0].file.size > maxSize;

  const clearFile = () => {
    setFetchedFile('');
    setFiles([]);
    // setSelectedFile("uploadedFile", []);
    setFilePathName('');
  };
  const clearallFile = () => {
    setFetchedFile('');
    setFiles([]);
    setSelectedFile('uploadedFile', []);
    setFilePathName('');
  };

  useEffect(() => {
    if (isFileTooLarge) {
      setFileSizeError(isFileTooLarge);
    } else {
      setFileSizeError(false);
    }
  }, [isFileTooLarge, setFileSizeError]);

  useEffect(() => {
    setFetchedFile(letterFormatData?.fileName);
    setFilePathName(letterFormatData?.fileName);
  }, [letterFormatData]);

  useEffect(() => {
    if (uploadedFile == null) {
      acceptedFiles.splice(0, 1);
      setFiles([]);
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (selectedFile == '') {
      setFiles('');
    }
  }, [selectedFile, files]);

  useEffect(() => {
    if (acceptedFiles.length > 0) {
      const files = acceptedFiles.map((file, i) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {};
        const remove = (file) => {
          acceptedFiles.splice(file, 1);
          setFiles([]);
          setSelectedFile('uploadedFile', []);
        };
        return (
          <ListItem key={file.path}>
            <span
              role="button"
              tabIndex={0}
              style={{cursor: 'pointer'}}
              onClick={() => viewhandler()}
            >
              {file.path}
              {setFilePathName(file.path)}
            </span>
            <Tooltip title="Delete">
              <DeleteRoundedIcon
                style={{cursor: 'pointer'}}
                onClick={() => {
                  remove(i);
                  setFilePathName('');
                }}
              />
            </Tooltip>
          </ListItem>
        );
      });
      setFiles(files);
    } else if (oldFile.length > 0 && !oldFile.includes('')) {
      const files = oldFile.map((file, i) => {
        const remove = (file) => {
          oldFile.splice(file, 1);
          setFiles([]);
        };
        return (
          <ListItem key={file}>
            <span
              role="button"
              tabIndex={0}
              style={{cursor: 'pointer'}}
              onClick={() => viewhandler()}
            >
              {i + 1}.{file}
            </span>
            <Tooltip title="Delete">
              <DeleteRoundedIcon style={{cursor: 'pointer'}} onClick={() => remove(i)} />
            </Tooltip>
          </ListItem>
        );
      });
      setFiles(files);
    }
  }, [acceptedFiles, setFieldValue, oldFile]);
  return (
    <>
      <Box className={classes.boxDrop}>
        <div className={`d-flex align-items-center`}>
          <Box {...getRootProps({className: 'dropzone d-flex  justify-content-around'})}>
            <input {...getInputProps()} />
            <Typography className={classes.uploadText}>Drag and drop file here</Typography>
            <Typography className={classes.uploadContent}>Or</Typography>
            <Button
              variant="outlined"
              disabled={capturedImages && capturedImages.length}
              onClick={() => {
                open();
                setFilePath(true);
                setFilePathName('');
                clearFile();
              }}
              className={classes.actionButton}
            >
              Browse
            </Button>
            {error && (
              <b className="text-danger mt-2">
                <p style={{color: 'red'}}>{helperText}</p>
              </b>
            )}
            {
              <span className="text-primary mt-2">
                <em className="mt-3">1.Total File size should be under 10MB</em>
                <br />
                <div className="text-primary mt-2">
                  <em>only supported file are : &apos;.dot&apos;, &apos;.dotx&apos;</em>
                </div>
              </span>
            }
            {fileSizeError && (
              <div className="text-danger mt-2">
                <em>File size is too large, file size should be under {fileSize}</em>
              </div>
            )}
            {/* {viewIconCond && fetchedFile ? (
              <Tooltip title="View">
                <ViewIcon
                  style={{
                    cursor: "pointer",
                    margin: "0px 10px 0 12px",
                  }}
                  onClick={() => viewhandler()}
                />
              </Tooltip>
            ) : (
              ""
            )} */}
          </Box>
        </div>
        <aside style={{marginLeft: '17px'}}>
          {acceptedFiles[0]?.size > 5242880 ? (
            <FormHelperText style={{color: 'red'}} variant="outlined">
              File size cannot exceed 5MB
            </FormHelperText>
          ) : (
            ''
          )}
        </aside>
        <aside>
          <List className={classes.documentText}>
            {/* {files}{" "} */}
            {fetchedFile && viewIconCond && !filePath && !selectedFile ? (
              <>
                <span role="button" tabIndex={0} onClick={() => viewhandler()}>
                  {fetchedFile}
                </span>
                <Tooltip title="Delete">
                  <DeleteRoundedIcon style={{cursor: 'pointer'}} onClick={() => clearFile()} />
                </Tooltip>
              </>
            ) : (
              ''
            )}
            {selectedFile && selectedFile.length > 0 ? (
              <>
                <span role="button" tabIndex={0} onClick={() => viewhandler()}>
                  {values?.uploadedFile?.[0]?.name}
                </span>
                <Tooltip title="Delete">
                  <DeleteRoundedIcon style={{cursor: 'pointer'}} onClick={() => clearallFile()} />
                </Tooltip>
              </>
            ) : (
              ''
            )}
          </List>
        </aside>
      </Box>
    </>
  );
};

export default DragAndDrop;
